import { motion } from "framer-motion";
import { ArrowUpRight, ArrowDown } from "lucide-react";
import videoTruviq from "../../assets/truviq.mp4";
import HeroVideo from "./Video";
import poster from "../../assets/images/poster.jpg";
import bg_node from "../../assets/images/bg_nodes.png";
const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.1, delayChildren: 0.1 } },
};
const item = {
  hidden: { opacity: 0, y: 24 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
  },
};
const handleScrollDown = () => {
  const nextSection =
    document.getElementById("capabilities") ||
    document.getElementById("about-us");
  if (nextSection) {
    nextSection.scrollIntoView({ behavior: "smooth" });
  } else {
    window.scrollBy({ top: window.innerHeight * 0.8, behavior: "smooth" });
  }
};
export default function Hero() {
  return (
    <section
      id="top"
      className="relative pt-40 md:pb-24 pb-12 md:pt-52  overflow-hidden bg-[#f5f5f5]"
    >
      <div className="top-10 absolute max-w-6xl  opacity-20">
        <img src={bg_node} alt="" />
      </div>
      <div
        className="pointer-events-none absolute top-0 left-0 w-full h-full opacity-20 "
        style={{
          background:
            "linear-gradient(135deg, #62d4f7 0%, #5dc9f0 40%, #3579be 60%",
        }}
      />
      <div className="mx-auto max-w-6xl px-6 relative flex flex-col items-center text-center">
    <motion.div
          variants={container}
          initial="hidden"
          animate="show"
          className="flex flex-col md:gap-4 gap-2 items-center"
        >
          <motion.div
            variants={item}
            className="inline-flex items-center px-4 py-1.5 rounded-full  backdrop-blur-md"
          >
            <span className="text-base font-medium text-[#000036]">
              Enterprise technology &amp; intelligent automation
            </span>
          </motion.div>

          <motion.h1
            variants={item}
            className=" text-balance text-4xl sm:text-6xl md:text-7xl font-semibold tracking-tight text-slate-950  "
          >
            <span className="font-serif italic font-normal text-gray-600">
              AI-Driven
            </span>{" "}
            Process Automation for the Enterprise
          </motion.h1>

          <motion.p
            variants={item}
            className="mt-6 text-lg sm:text-xl text-[#000036] max-w-2xl leading-relaxed"
          >
            At the intersection of AI, BPM, and low-code platforms, Truviq helps
            enterprises drive efficiency, reduce complexity, and deliver faster
            outcomes.
          </motion.p>
          <motion.div
            variants={item}
            className="mt-8 flex flex-wrap items-center justify-center gap-4"
          >
            <a
              href="#contact"
              className="group relative inline-flex items-center justify-between gap-3 px-5 py-3 border border-black/15 bg-slate-950 text-white font-mono text-xs font-semibold uppercase tracking-widest transition-all duration-300 hover:bg-white hover:text-slate-700 hover:shadow-lg"
              style={{
                borderRadius: "999px",
              }}
            >
              <span>Explore Capabilities</span>
              <div className="h-7 w-7 rounded-full bg-white/10 flex items-center justify-center transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-0.5 group-hover:bg-slate-700 group-hover:text-white">
                <ArrowUpRight size={15} />
              </div>
            </a>
            <a
              href="#contact"
              className="group relative inline-flex items-center justify-between gap-3 px-5 py-3 border border-black/15  bg-white/40 text-slate-900 font-mono text-xs font-semibold uppercase tracking-widest transition-all duration-300 hover:bg-slate-950 hover:text-white hover:shadow-lg"
              style={{
                borderRadius: "999px",
              }}
            >
              <span>Talk to an Expert</span>
              <div className="h-7 w-7 rounded-full bg-white/10 flex items-center justify-center transition-transform duration-300 group-hover:translate-y-1  group-hover:bg-white group-hover:text-slate-950">
                <ArrowDown size={15} />
              </div>
            </a>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="mt-10 md:mt-16 flex flex-col items-center"
          >
            <button
              onClick={handleScrollDown}
              className="group flex flex-col items-center gap-2 text-slate-500 hover:text-slate-950 transition-colors duration-300"
              aria-label="Scroll to next section"
            >
              <span className="text-xs font-semibold tracking-widest uppercase text-slate-400 group-hover:text-slate-900 transition-colors">
                Scroll to explore
              </span>
              <div className="w-9 h-9 rounded-full border border-black/10 bg-white/70 backdrop-blur-sm flex items-center justify-center shadow-sm group-hover:bg-white group-hover:border-black/20 group-hover:shadow transition-all duration-300">
                <motion.div
                  animate={{ y: [0, 4, 0] }}
                  transition={{
                    repeat: Infinity,
                    duration: 1.5,
                    ease: "easeInOut",
                  }}
                >
                  <ArrowDown
                    size={18}
                    className="text-slate-700 group-hover:text-slate-950"
                  />
                </motion.div>
              </div>
            </button>
          </motion.div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 35, scale: 0.97 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="mt-14 sm:mt-16 w-full"
        >
          <HeroVideo src={videoTruviq} poster={poster} />
        </motion.div>
      </div>
    </section>
  );
}
